import React from "react";
import { useStudent } from "src/contexts/student";
import {
  GetStudentStatus,
  studentStatus,
} from "src/screens/student-info/student-status";
import { StudentList } from "..";
import dummy from "../../../assets/png/userd-demo-pic.png";

const Students: React.FC<{
  list: StudentList[];
  onSelect(s: StudentList): void;
}> = ({ list, onSelect }) => {
  const student = useStudent();

  GetStudentStatus;

  return (
    <>
      {list.map((element, index) => (
        <button
          key={`${index}`}
          className={`relative mb-2 flex flex-row items-center rounded-lg p-2 transition-colors ${
            element.id === student.student?.id
              ? "cursor-not-allowed bg-zinc-300"
              : "cursor-pointer bg-zinc-100 hover:bg-zinc-300"
          } `}
          disabled={element.id === student.student?.id}
          onClick={() => onSelect(element)}
        >
          <img
            src={element.photourl ?? dummy}
            alt="avatar"
            className="mr-3 h-10 w-10 rounded-full"
          />
          <div className="flex flex-1 items-center justify-between">
            <p className="text-sm">{element.name}</p>
            <p
              className="text-xs font-semibold"
              style={{
                color: studentStatus[element.status].color,
              }}
            >
              {studentStatus[element.status].label}
            </p>
          </div>
        </button>
      ))}
    </>
  );
};

export default Students;
